export default __webpack_public_path__ + "img/sidebar_appointments.0a05aa56.svg";